import { render, staticRenderFns } from "./expenses.vue?vue&type=template&id=52e96bb3&scoped=true&"
import script from "./expenses.vue?vue&type=script&lang=js&"
export * from "./expenses.vue?vue&type=script&lang=js&"
import style0 from "./expenses.vue?vue&type=style&index=0&id=52e96bb3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e96bb3",
  null
  
)

export default component.exports